import { WikiPage } from "../WikiPage";
export class WikiPageMethodEditing extends WikiPage {
    render() {
        this.todo();
    }
}
